import { Dialog } from "@components/ui/Dialog"
import { cn } from "@utils/tw"
import { useIsSSR, useRoute } from "eddev/routing"
import { useEffect, useLayoutEffect, useMemo, useState } from "react"
import { useSquadup } from "./useSquadUp"
import { useAuth } from "@features/accounts/useAuth"
import { useRPCQuery } from "eddev/hooks"
import { SquadupUtils } from "./squadup/squadup-utils"

export function SquadupModal() {
  if (!env.client) return null

  const route = useRoute()

  const squadup = useSquadup()
  const [visible, setVisible] = useState(false)

  const hydrating = useIsSSR()

  const target = useMemo(() => {
    if (env.client) {
      return document.createElement("div")
    }
  }, [])

  const auth = useAuth()
  const accountLookup = useRPCQuery(
    "api.memberships.getAccount",
    { jwt: auth.session?.access_token! },
    {
      staleTime: 300,
      refetchInterval: 0,
      enabled: auth.loggedIn,
    },
  )

  useEffect(() => {
    if (!target) return
    const codes = accountLookup.data?.codes

    let ignoreNextMutation = false
    const updateCodes = () => {
      ignoreNextMutation = true
      target.querySelectorAll(".squadup-code-selector").forEach((el) => {
        el.remove()
      })
      const promoInputs = target.querySelectorAll("input[name='promo_codes']")
      promoInputs.forEach((input) => {
        const container = input.parentElement!
        const discountPicker = document.createElement("div")
        const applyButton = container.parentElement!.querySelector("button")
        discountPicker.className = "squadup-code-selector"
        container.appendChild(discountPicker)
        codes?.forEach((code) => {
          const option = document.createElement("button")
          option.className = "squadup-code-selector-option"
          option.textContent = code.applyLabel
          option.onclick = () => {
            SquadupUtils.triggerChange(input as HTMLInputElement, code.code)
            SquadupUtils.triggerClick(applyButton as HTMLButtonElement)
          }
          discountPicker.appendChild(option)
        })
      })
    }

    const observer = new MutationObserver((mutations) => {
      if (!ignoreNextMutation) {
        updateCodes()
      } else {
        ignoreNextMutation = false
      }
    })
    observer.observe(target!, {
      childList: true,
      subtree: true,
    })
    return () => {
      observer.disconnect()
    }
  }, [target, accountLookup.data?.codes])

  useEffect(() => {
    if (!hydrating) {
      return squadup.state.registerContainerCandidate({
        element: target!,
        getPriority: () => 1,
        onVisibleChange: setVisible,
      })
    }
  }, [hydrating])

  useEffect(() => {
    setTimeout(() => {
      squadup.init()
    }, 1000)
  }, [])

  // Close any SquadUp embeds on route change
  useEffect(() => {
    squadup.close()
  }, [route.pathname])

  return (
    <Dialog
      open={visible}
      onDismiss={() => squadup.close()}
      padded={false}
      onOpenChange={() => {
        squadup.close()
        setVisible(false)
      }}
    >
      <Dialog.Title hidden>Purchase Tickets</Dialog.Title>
      <Dialog.Description hidden>Purchase Tickets</Dialog.Description>
      <div
        className={cn("squadup-dialog-wrapper w-[90vw] md:w-dialogW")}
        ref={(el) => {
          if (el) {
            el.appendChild(target!)
          }
        }}
      ></div>
    </Dialog>
  )
}
